<template>
  <div id="page-layout">
    <div id="page-header">
      <div class="page-title-layout">
        <router-link class="bc-link" :to="{name: 'profileManage'}">
          {{$t("header.my_profile")}}
        </router-link>
        <i class="fas fa-angle-right"></i>
        <p>{{$t("header.title_edit")}}</p>
      </div>
    </div>
    <form
      class="edit-form"
      novalidate
      autocomplete="off"
      @submit.prevent="handleSubmit"
      name="profileEdit">

      <!--Workaround because FF auto-complete the first password field and the input text just before-->
      <input type="password" style="display: none">

      <c-input name="firstName" label="user.first_name" v-model.trim="profile.firstName"
               inputClass="large-input" type="text" v-validate="'required'"/>

      <c-input name="lastName" label="user.last_name" v-model.trim="profile.lastName"
               inputClass="large-input" type="text" v-validate="'required'"/>

      <c-input name="companyName" label="user.company" v-model.trim="profile.companyName"
               v-if="isClient()" inputClass="large-input" type="text" v-validate="'required'"/>

      <!--We need fake name to avoid autocomplete on Chrome-->
      <c-input name="xxx" label="user.email" v-model.trim="profile.email" :disabled="!isSuperAdmin()"
               inputClass="large-input" type="text" v-validate="'required|email'"/>

      <div class="field">
        <label for="language">{{ $t("user.language") }}</label>
        <v-select class="small-input" id="language" v-model="selectedLocale" :options="getLocales()"
                  :searchable="false"/>
      </div>

      <c-input name="passwordOld" label="user.password_old" v-model.trim="profile.passwordOld"
               inputClass="small-input" type="password" v-validate="'password'"
               ref="passwordOld" data-vv-as="passwordOld"/>

      <c-input name="passwordNew" label="user.password_new" v-model.trim="profile.passwordNew"
               inputClass="small-input" type="password" v-validate="'password'"
               ref="passwordNew" data-vv-as="passwordNew"/>

      <c-input name="passwordNewConfirm" label="user.password_new_confirm" v-model.trim="profile.passwordNewConfirm"
               inputClass="small-input" type="password" v-validate="'password'"
               ref="passwordNewConfirm" data-vv-as="passwordNewConfirm"/>

      <div class="actions">
        <input class="solid-button" type="submit" v-bind:value="$t('actions.save')"/>
        <input class="ghost-button" type="button" v-bind:value="$t('actions.cancel')" v-on:click="cancel()"/>
      </div>
    </form>
  </div>
</template>

<script>
  import Roles from "../models/Roles.js"
  import Profile from "../models/Profile.js"
  import userService from "../services/userService.js"
  import Utils from "../services/utils.js"

  export default {
    data() {
      return {
        profile: new Profile(),
        originalEmail: "",
        selectedLocale: null
      };
    },
    watch: {
      selectedLocale(localeObj) {
        this.profile.locale = localeObj.value;
      }
    },
    methods: {
      isClient() {
        return this.profile.role === Roles.client;
      },
      isSuperAdmin() {
        return this.profile.role === Roles.superAdmin;
      },
      getLocales() {
        return [
          {label: this.$t("languages.fr"), value: "fr"},
          {label: this.$t("languages.en"), value: "en"}];
      },
      handleSubmit() {
        const emailChanged = this.originalEmail !== this.profile.email;
        this.$validator.validate().then(valid => {
          if (!Utils.isBlank(this.profile.passwordNew) && Utils.isBlank(this.profile.passwordOld)) {
            this.errors.add({
              field: 'passwordOld',
              msg: this.$t('messages.pwd_required')
            });
            valid = false
          }
          if (!Utils.isBlank(this.profile.passwordNew) && this.profile.passwordNew !== this.profile.passwordNewConfirm) {
            this.errors.add({
              field: 'passwordNew',
              msg: this.$t('messages.pwd_confirm')
            });
            this.errors.add({
              field: 'passwordNewConfirm',
              msg: this.$t('messages.pwd_confirm')
            });
            valid = false
          }
          if (valid) {
            userService.updateProfile(this.profile).then((response) => {
              this.$i18n.locale = this.profile.locale;

              this.$store.dispatch('user/login'); // update store
              this.$store.dispatch('alert/success', this.$t(`alerts.profile_update_success`));

              if(emailChanged) {
                userService.logout();
                this.$store.dispatch('user/logout');
                this.$router.push({name: 'login'})
              } else {
                this.$router.push({name: 'home'})
              }

            }).catch((error) => {
              this.$store.dispatch('alert/error', {
                message: this.$t(`alerts.profile_update_error`),
                error: error
              });
            });
          }
        });
      },
      cancel() {
        this.$router.push({name: 'home'})
      },
      selectLocale(locale) { // v-select need an object...
        this.selectedLocale = this.getLocales().find(function (e) {
          return e.value === locale;
        });
      }
    },
    mounted() {
      userService.getCurrentUser().then(result => {
        this.profile = result;
        this.originalEmail = this.profile.email;
        this.selectLocale(result.locale);
      });
    }
  }
</script>

<style lang="scss" scoped>
  @import '../style/form.scss';

  #page-layout {
    display: grid;
    grid-template-columns: 20% [content] auto 20%;
  }

  #page-header {
    @extend %common-header;
  }
</style>



// WEBPACK FOOTER //
// src/pages/editProfile.vue